import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useKitData from "@/hooks/data/use-kit-data";
import usePopOver from "@/hooks/use-popover";
import { IKitComponentInput } from "@/interfaces/kit.interface";
import { KitTableMessages } from "@/messages/products/kit-table.messages";

import { KitPopover } from "../kitPopover";

interface Props {
  kit: IKitComponentInput;
  index: number;
  messages: KitTableMessages;
  onEdit: (kit: IKitComponentInput) => void;
  onRemove: (kit: IKitComponentInput) => void;
}

export function KitTableRow({ kit, index, messages, onEdit, onRemove }: Props) {
  const usePopover = usePopOver<IKitComponentInput>();
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopover;

  const { qty, title } = useKitData({ kit });

  return (
    <TableRow index={index}>
      <TableCell>{title}</TableCell>
      <TableCell>{qty}</TableCell>

      <TableCell>
        <IconButton
          onClick={(e) => {
            openPopover(e, kit);
          }}
        >
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <KitPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            onEdit={onEdit}
            onRemove={onRemove}
            messages={messages}
            selectedKit={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
